import { Component, Inject, OnInit } from "@angular/core";
import { AbstractControl, UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";
import { AppConfig } from "src/app/configs/app.config";
import { CommonService } from "src/app/core/services/common.service";
import { UserService } from "src/app/core/services/user.service";
import { PaymentDetails } from "src/app/models/user";
import { TermsConditionsComponent } from "../terms-conditions/terms-conditions.component";
import { PaymentInfoService } from "src/app/core/services/payment-info.service";
import { AdvertiserService } from "src/app/core/services/advertiser.service";
import { AgencyService } from "src/app/core/services/agency.service";
@Component({
  selector: "app-add-funds",
  templateUrl: "./add-funds.component.html",
  styleUrls: ["./add-funds.component.scss"],
})
export class AddFundsComponent implements OnInit {
  paymentDetails = new PaymentDetails();
  panelOpenState = false;
  totalPayableAmount;
  payableAmountAvailable: boolean = false;
  isValid: boolean;
  isAgreed: boolean;
  params = {};
  stripeLimit: number = 10000;
  minStripeLimit: number = 1;
  maxStripeLimit: number = 10000;
  amountControl: UntypedFormGroup;
  currencyOptions: Array<any> = [
    { value: "USD", name: "USD" }
  ];

  payInfoTitle = {
    creditCard: "Card Payment",
    ach: "ACH transfer instructions",
    us: "Wire transfer (US Banks) instructions",
    nonUS: "Wire transfer (non-US Banks) instructions"
  }

  readonly nonCardPayInfo = {
    creditCard: null,
    ach: "Instruct the paying financial institution or the payor to route all domestic wire transfers via FEDWIRE to the following ABA number:",
    us: "Instruct the paying financial institution or the payor to route all domestic wire transfers via FEDWIRE to the following ABA number:",
    nonUS:
      "Instruct the paying financial institution to advise their U.S. correspondent to pay as follows:",
  };

  nonCardPayDetails = {
    creditCard: [],
    ach: [
    ],
    us: [
    ],
    nonUS: [
    ],
  };
  readonly imgPath: string;
  readonly platformName!: string;
  readonly creditForName!: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public addFundsService: UserService,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    private formBuilder: UntypedFormBuilder,
    private advertiserService: AdvertiserService,
    private agencyService: AgencyService,
    private commonService: CommonService,
    private paymentInfoSvc: PaymentInfoService
  ) {
    this.imgPath = AppConfig.POPUP_LOGO;
    this.platformName = AppConfig.TITLE;
    this.creditForName = AppConfig.CREDIT_FOR;
  }

  ngOnInit(): void {
    if (this.data.advertiser_id)
      this.params["advertiser_id"] = this.data.advertiser_id;
    else this.params["agency_id"] = this.data.agency_id;
    this.amountControl = this.formBuilder.group({
      entries: ["", [Validators.min(this.minStripeLimit), Validators.max(this.maxStripeLimit)]],
    });
    if (this.data.currency != 'USD') this.currencyOptions.unshift({value : this.data.currency, name : this.data.currency})
    this.paymentDetails.transaction_currency = this.data.currency
    this.getPaymentInfo();
    this.fetchStripeLimit();
  }

  getPaymentInfo() {
    this.paymentInfoSvc.fetchPaymentInfo(this.params).subscribe({
        next: (res) => {
          this.nonCardPayDetails = res.offline_payment_details
        },
        error: () => {
        },
    })
  }

  get payeeEmail(): string | undefined {
    return this.nonCardPayDetails[this.data.type]?.find(
      d => d.label.toLowerCase() === 'email'
    )?.value;
  }

  fetchStripeLimit() {
    const onResult = (res) => {
      this.minStripeLimit = res?.data?.min ?? this.minStripeLimit;
      this.maxStripeLimit = res?.data?.max ?? this.maxStripeLimit;

      const ctrl = this.amountControl.controls.entries;
      ctrl.setValidators([
        Validators.min(this.minStripeLimit),
        Validators.max(this.maxStripeLimit),
      ]);
      ctrl.updateValueAndValidity();
      this.validate();
    };
    if (this.data.advertiser_id) {
      this.advertiserService.getStripePaymentLimit(this.data.advertiser_id, 
        {advertiser_id: this.data.advertiser_id, currency: this.paymentDetails.transaction_currency}).subscribe(onResult);
    } else if (this.data.agency_id) {
      this.agencyService.getStripePaymentLimit(this.data.agency_id, 
        {agency_id: this.data.agency_id, currency: this.paymentDetails.transaction_currency}).subscribe(onResult);
    }
  }

  openTnc() {
    let dialogRef = this.dialog.open(TermsConditionsComponent, {
      width: "55%",
      height: "70%",
      disableClose: true,
    });
  }

  closeModel() {
    this.dialogRef.close();
  }

  validateAmount(){
    return (control: AbstractControl): ValidationErrors | null => {
      let inValidData = {};
      let amount = control.value
      if ( amount < 1){
        inValidData['minError'] = true
      }
       if ( amount > this.stripeLimit){
        inValidData['maxError'] = true
      }
      return inValidData
    }
  }

  validate() {
    this.isValid = true;
    if (!this.paymentDetails.amount || this.paymentDetails.amount < 0) {
      this.isValid = false;
    }
    if (!this.paymentDetails.description) {
      this.isValid = false;
    }
    if (!this.isAgreed) {
      this.isValid = false;
    }
    if (this.amountControl.controls.entries.errors != null) {
      this.isValid = false;
    }
  }

  public getTotalAmount() {
    this.addFundsService.totalPayableAmount(this.paymentDetails, this.params).subscribe(
      (res) => {
        this.totalPayableAmount = res
        this.payableAmountAvailable = true
      });
  }

  public createPgsession() {
    this.addFundsService.createPgSession(this.paymentDetails, this.params).subscribe(
      (res) => {
        this.commonService.goToExternalDomain(res.data.url);
      });
  }
}
